/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/*
 * Just set css to the header of the page
 */
var $ = require('jquery');
var escapeHtml = require('escape-html');

module.exports = function (cssUrl) {
    if (!cssUrl) {
        return;
    }

    $('head').append('<link rel="stylesheet" type="text/css" href="' + escapeHtml(cssUrl) + '">');
};
